import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import VendorMarketplace from '../customers/tabs/vendors/VendorMarketplace';
import SubmitMileageDrivers from '../customers/tabs/assets/SubmitMileageDrivers';
import Cards from '../customers/tabs/banking/cards/Cards';

interface DriverDashboardProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
  showSideNav: boolean;
  setShowSideNav: (show: boolean) => void;
}

function DriverDashboard({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
  showSideNav,
  setShowSideNav,
}: DriverDashboardProps) {
  const [currSubPage, setCurrSubPage] = useState<string | null>(null);
  const handleSetSubPage = (page: string | null) => {
    setCurrSubPage(page);
  };
  const commonProps = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
    currSubPage,
    setCurrSubPage: handleSetSubPage,
  };

  return (
    <Routes>
      <Route path="/" element={<VendorMarketplace {...commonProps} />} />
      <Route
        path="home"
        element={<Navigate to="/dashboard/vendor-marketplace" replace />}
      />
      <Route
        path="vendor-marketplace/*"
        element={<VendorMarketplace {...commonProps} />}
      />
      <Route
        path="submit-mileage-drivers"
        element={<SubmitMileageDrivers {...commonProps} />}
      />
      <Route path="cards-drivers/*" element={<Cards isDriver />} />
    </Routes>
  );
}

export default DriverDashboard;
